<template>
  <v-container fluid v-if="egreso">
    <v-row class="justify">
      <v-col cols="12" md="8">

 
    <v-row align="center" class="mb-4">
      <v-col cols="12" md="6" class="d-flex align-center">
        <v-btn icon @click="$router.push({ name: 'SucursalEgresosGastos' })">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <h2 class="font-weight-bold mb-0 ml-2">Editar gasto</h2>
      </v-col>

      <v-col cols="12" md="6" class="text-right">
        <v-btn large color="primary" @click="actualizarEgreso()">
          Actualizar Egreso
        </v-btn>
      </v-col>
    </v-row>

    <!-- FORMULARIO PRINCIPAL -->
    <v-row>
      <v-col cols="12" md="8">
        <GastoForm :egreso="egreso"></GastoForm>

        <!-- Detalles listados -->
        <v-list two-line class="mt-4">
          <v-list-item v-for="(detalle, index) in egreso.detalles" :key="index">
            <v-list-item-content>
              <v-list-item-title>{{ detalle.descripcion }}</v-list-item-title>
              <v-list-item-subtitle>{{
                Number(detalle.monto) | convertPesoArg
              }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn icon @click="openDialogEditar(detalle)">
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
              <v-btn icon @click="quitarDetalle(detalle)">
                <v-icon small color="red">mdi-delete</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>

        <!-- Dialog Detalle Registrar -->
        <v-dialog width="600" v-model="dialogDetalleRegistrar">
          <ValidationObserver ref="formDetalleRegistrar">
            <v-card>
              <v-card-title>
                Nuevo detalle
                <v-spacer></v-spacer>
                <v-icon color="blue" @click="dialogDetalleRegistrar = false"
                  >mdi-close</v-icon
                >
              </v-card-title>
              <v-card-text>
                <VTextAreaWithValidation
                  outlined
                  label="Descripción"
                  autofocus
                  v-model="detalle.descripcion"
                  rules="required|max:100"
                  :counter="100"
                  rows="3"
                  row-height="30"
                />
                <VTextFieldWithValidation
                  outlined
                  label="Monto"
                  v-model="detalle.monto"
                  rules="required|decimal|max:30"
                  @keyup.enter="añadirDetalle()"
                />
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-btn text @click="dialogDetalleRegistrar = false"
                  >Cancelar</v-btn
                >
                <v-btn color="success" @click="añadirDetalle()">Guardar</v-btn>
              </v-card-actions>
            </v-card>
          </ValidationObserver>
        </v-dialog>

        <!-- Dialog Detalle Actualizar -->
        <v-dialog width="600" v-model="dialogDetalleActualizar">
          <ValidationObserver ref="formDetalleActualizar">
            <v-card>
              <v-card-title>
                Actualizar detalle
                <v-spacer></v-spacer>
                <v-icon color="blue" @click="dialogDetalleActualizar = false"
                  >mdi-close</v-icon
                >
              </v-card-title>
              <v-card-text>
                <VTextAreaWithValidation
                  outlined
                  label="Descripción"
                  autofocus
                  v-model="detalle.descripcion"
                  rules="required|max:100"
                  :counter="100"
                  rows="3"
                  row-height="30"
                />
                <VTextFieldWithValidation
                  outlined
                  label="Monto"
                  v-model="detalle.monto"
                  rules="required|decimal|max:30"
                  @keyup.enter="modificarDetalle(detalle)"
                />
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-btn text @click="dialogDetalleActualizar = false"
                  >Cancelar</v-btn
                >
                <v-btn color="success" @click="modificarDetalle(detalle)"
                  >Guardar</v-btn
                >
              </v-card-actions>
            </v-card>
          </ValidationObserver>
        </v-dialog>
      </v-col>
    </v-row>
         </v-col>
    </v-row>
  </v-container>
</template>

<script>
import GastoForm from "@/views/empresa/sucursales/egresos/components/GastoForm.vue";
import { ValidationObserver } from "vee-validate";
import VTextFieldWithValidation from "@/components/inputs/VTextFieldWithValidation";
import VTextAreaWithValidation from "@/components/inputs/VTextAreaWithValidation";
import moment from "moment";

export default {
  name: "egreso.actualizar",
  components: {
    GastoForm,
    ValidationObserver,
    VTextFieldWithValidation,
    VTextAreaWithValidation,
  },
  data() {
    return {
      egreso: null,
      detalle: { descripcion: "", monto: null },
      dialogDetalleRegistrar: false,
      dialogDetalleActualizar: false,
      detalles_server_update: [],
      detalles_server_delete: [],
      detalles_server_new: [],
    };
  },
  filters: {
    convertPesoArg(value) {
      return `$ ${new Intl.NumberFormat("de-DE").format(value)}`;
    },
  },
  computed: {
    formatFechaPeriodo() {
      return moment(this.egreso.fechaPeriodo).format("MMMM-YYYY").toUpperCase();
    },
  },
  methods: {
    subtotal() {
      return this.egreso.detalles.reduce(
        (total, d) => total + parseFloat(d.monto || 0),
        0
      );
    },
    async añadirDetalle() {
      const result = await this.$refs.formDetalleRegistrar.validate();
      if (!result) return;

      this.egreso.detalles.push({ ...this.detalle });
      this.detalles_server_new.push({ ...this.detalle });
      this.detalle = { descripcion: "", monto: null };
      this.$refs.formDetalleRegistrar.reset();
      this.dialogDetalleRegistrar = false;
    },
    openDialogEditar(detalle) {
      this.detalle = { ...detalle };
      this.dialogDetalleActualizar = true;
    },
    modificarDetalle(detalle) {
      const index = this.egreso.detalles.findIndex((d) => d.id === detalle.id);
      if (index !== -1) {
        this.egreso.detalles[index] = { ...detalle };
        this.dialogDetalleActualizar = false;
      }
      // también actualizar arrays de server si es necesario
    },
    quitarDetalle(detalle) {
      const index = this.egreso.detalles.indexOf(detalle);
      if (index >= 0) {
        if (detalle.id) {
          detalle.accion = 0;
          this.detalles_server_delete.push(detalle);
        } else {
          const idxNew = this.detalles_server_new.indexOf(detalle);
          if (idxNew >= 0) this.detalles_server_new.splice(idxNew, 1);
        }
        this.egreso.detalles.splice(index, 1);
      }
    },
    async actualizarEgreso() {
      try {
        let detalles = [
          ...this.detalles_server_update,
          ...this.detalles_server_delete,
          ...this.detalles_server_new,
        ];
        this.egreso.detalles = detalles;

        await this.axios.put(
          `/egresos/ingresoegreso/${this.egreso.id}`,
          this.egreso
        );

        this.$updateBus.$emit("showSnackBar", {
          show: true,
          color: "success",
          text: "Egreso actualizado",
          icon: "mdi-check",
        });
        this.$router.push({ name: "SucursalEgresosGastosCategoria" });
      } catch (error) {
        console.error(error);
      }
    },
    async fetchEgreso(id) {
      const response = await this.axios.get(`/egresos/ingresoegreso/${id}`);
      this.egreso = response.data;
    },
  },
  created() {
    const id = this.$route.params.id;
    this.fetchEgreso(id);
  },
};
</script>
